import { initializeExplorer } from '../lib/explorer/src/index'

declare global {
  interface Window {
    gtag: any
  }
}

if (document.getElementById('explorer')) {
  const mainNav = document.querySelector('#main-nav, nav')
  mainNav.classList.add('relative')
  mainNav.classList.remove('sticky')
  const base = '/explorer'
  // Todo, disable first pageview in base tracking https://developers.google.com/analytics/devguides/collection/gtagjs#install_the_global_site_tag
  initializeExplorer(document.getElementById('explorer'), {
    base,
    onNavigate: ({ title, location }) => {
      window.gtag('event', 'page_view', {
        page_title: `${title} – Explorer`,
        page_path: `${base}${location.pathname}`,
        app_area: 'explorer',
      })
    },
  })
  document.getElementById('explorer-skeleton').remove()
}
